import { useEffect } from 'react';
import { Icono } from '../componentes/Icono';
import type { NombreIcono } from '../componentes/iconos';

/**
 * Teclado numérico de la tablet (1.13): 1–9, 0 y borrar, teclas de 96 radio 16 `--rv-paper`. La casilla libre de abajo a
 * la izquierda lleva, si la pantalla la necesita, la tecla de confirmar (el PIN tiene de 4 a 6 cifras: no se envía solo).
 * También vale el teclado físico.
 */
export function Teclado({ onDigito, onBorrar, confirmar }: { onDigito: (d: string) => void; onBorrar: () => void; confirmar?: { etiqueta: string; icono: NombreIcono; activo: boolean; accion: () => void } }) {
    useEffect(() => {
        const tecla = (e: KeyboardEvent) => {
            if (/^[0-9]$/.test(e.key)) {
                onDigito(e.key);
            } else if (e.key === 'Backspace') {
                onBorrar();
            } else if (e.key === 'Enter' && confirmar?.activo === true) {
                confirmar.accion();
            }
        };
        window.addEventListener('keydown', tecla);
        return () => {
            window.removeEventListener('keydown', tecla);
        };
    }, [onDigito, onBorrar, confirmar]);

    return (
        <div className="rv-teclado" role="group" aria-label="Teclado numérico">
            {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (
                <button key={d} type="button" className="rv-teclado__t" onClick={() => { onDigito(d); }}>
                    {d}
                </button>
            ))}
            {confirmar === undefined ? (
                <span />
            ) : (
                <button type="button" className="rv-teclado__t rv-teclado__t--ok" aria-label={confirmar.etiqueta} disabled={!confirmar.activo} onClick={confirmar.accion}>
                    <Icono nombre={confirmar.icono} />
                </button>
            )}
            <button type="button" className="rv-teclado__t" onClick={() => { onDigito('0'); }}>
                0
            </button>
            <button type="button" className="rv-teclado__t rv-teclado__t--borrar" aria-label="Borrar" onClick={onBorrar}>
                <Icono nombre="delete" />
            </button>
        </div>
    );
}
